import { render, staticRenderFns } from "./BadgeModal.vue?vue&type=template&id=7bee84e2&scoped=true&"
import script from "./BadgeModal.vue?vue&type=script&lang=js&"
export * from "./BadgeModal.vue?vue&type=script&lang=js&"
import style0 from "./BadgeModal.vue?vue&type=style&index=0&id=7bee84e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bee84e2",
  null
  
)

export default component.exports